import { NotFound } from '@/components';
import type { FC } from 'react';

import CommentLayout from '../layouts/CommentLayout';

const NotFoundPage: FC = () => {
  return (
    <CommentLayout>
      <NotFound />
    </CommentLayout>
  );
};

export default NotFoundPage;
